// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2x-6";
export var headerCell = "_2x-2";
export var rowWrapper = "_2x-4";
export var stickyAggregationCell = "_2x-a";
export var stickyAggregationRow = "_2x-7";
export var stickyColumnCell = "_2x-9";
export var stickyColumnHeaderCell = "_2x-8";
export var table = "_2x-1";
export var virtualRowWrapper = "_2x-5";
export var virtualTableContainer = "_2x-0";
export var white = "_2x-3";